import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  if (!authorization?.globalAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need the admin role to manage vendors."
      />
    );
  }
  return <>{children}</>;
};

export default AdminRoute;
